import { render, staticRenderFns } from "./PaymentDialog.vue?vue&type=template&id=52a25ec6"
import script from "./PaymentDialog.vue?vue&type=script&lang=js"
export * from "./PaymentDialog.vue?vue&type=script&lang=js"
import style0 from "./PaymentDialog.vue?vue&type=style&index=0&id=52a25ec6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports